// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/common/v1/surface/v1/types.proto (package creativefabrica.common.v1.surface.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file creativefabrica/common/v1/surface/v1/types.proto.
 */
export const file_creativefabrica_common_v1_surface_v1_types: GenFile = /*@__PURE__*/
  fileDesc("CjBjcmVhdGl2ZWZhYnJpY2EvY29tbW9uL3YxL3N1cmZhY2UvdjEvdHlwZXMucHJvdG8SJGNyZWF0aXZlZmFicmljYS5jb21tb24udjEuc3VyZmFjZS52MSq1AQoHU3VyZmFjZRIXChNTVVJGQUNFX1VOU1BFQ0lGSUVEEAASEgoOU1VSRkFDRV9TVFVESU8QARIXChNTVVJGQUNFX0ZSRUVNT0RFX0FJEAISDwoLU1VSRkFDRV9BUEkQAxIPCgtTVVJGQUNFX01DUBAEEhUKEVNVUkZBQ0VfVU5MSU1JVEVEEAUSFwoTU1VSRkFDRV9NQVJLRVRQTEFDRRAGEhIKDlNVUkZBQ0VfTU9CSUxFEAdCW1pZZ2l0aHViLmNvbS9jcmVhdGl2ZWZhYnJpY2Evc2NoZW1hcy9wa2cvZ2VuL2NyZWF0aXZlZmFicmljYS9jb21tb24vdjEvc3VyZmFjZS92MTtzdXJmYWNldjFiBnByb3RvMw");

/**
 * @generated from enum creativefabrica.common.v1.surface.v1.Surface
 */
export enum Surface {
  /**
   * @generated from enum value: SURFACE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SURFACE_STUDIO = 1;
   */
  STUDIO = 1,

  /**
   * @generated from enum value: SURFACE_FREEMODE_AI = 2;
   */
  FREEMODE_AI = 2,

  /**
   * API and MCP are derived by the server from the connection, never accepted
   * from a request: billing and retention key off them.
   *
   * @generated from enum value: SURFACE_API = 3;
   */
  API = 3,

  /**
   * @generated from enum value: SURFACE_MCP = 4;
   */
  MCP = 4,

  /**
   * @generated from enum value: SURFACE_UNLIMITED = 5;
   */
  UNLIMITED = 5,

  /**
   * @generated from enum value: SURFACE_MARKETPLACE = 6;
   */
  MARKETPLACE = 6,

  /**
   * @generated from enum value: SURFACE_MOBILE = 7;
   */
  MOBILE = 7,
}

/**
 * @generated from enum creativefabrica.common.v1.surface.v1.Surface
 */
export type SurfaceJson = "SURFACE_UNSPECIFIED" | "SURFACE_STUDIO" | "SURFACE_FREEMODE_AI" | "SURFACE_API" | "SURFACE_MCP" | "SURFACE_UNLIMITED" | "SURFACE_MARKETPLACE" | "SURFACE_MOBILE";

/**
 * Describes the enum creativefabrica.common.v1.surface.v1.Surface.
 */
export const SurfaceSchema: GenEnum<Surface, SurfaceJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_common_v1_surface_v1_types, 0);

